export const messages_sv = {
    nameEmpty: "Namn kan inte vara tomt.",
    emailEmpty: "E-postadress kan inte vara tom.",
    emailNotValid: "E-postadressen är inte giltig, vänligen ange en riktig e-postadress.",
    locationEmpty: "Plats kan inte vara tomt.",
    interests: "Välj 3 intresseområde.",
    profileSaved: "Profiluppgifter sparade.",
    profilePic: "Profilbild sparad.",
    addToFavorites: "Framgångsrikt tillagt till din favorit",
    removeFromFavorites: "framgångsrikt borttaget från favorit"
};


// WEBPACK FOOTER //
// ./src/constants/messages_sv.js